import { render, staticRenderFns } from "./APIRequestDetails.vue?vue&type=template&id=464aaf1e&"
import script from "./APIRequestDetails.vue?vue&type=script&lang=js&"
export * from "./APIRequestDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports